import React from 'react';
import { List, ListItem } from 'material-ui/List';
import { Route, Switch } from 'react-router-dom';
import Divider from 'material-ui/Divider';
import Translate from 'translate';

import Facebook from './facebook/';
import Twitter from './twitter/';
import BroadcastList from './list/';

class Configuration extends React.Component {

  getActiveTabStyle( url ) {
    return this.props.location.pathname.indexOf( url ) !== -1 ? { backgroundColor: 'rgba(153,153,153,0.4)' } : {}
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row mt-5">

          <div className="col-md-3">
            <section className="box box-default broadcast-sidebar">
              <div className="box-header"><Translate id="socialNetworks"/></div>
              <div className="box-body py-0">
                <List>
                  <ListItem primaryText="Facebook"
                            leftIcon={<i className="fa text-center fa-facebook-f" style={{ fontSize: 20 }}/>}
                            onClick={() => this.props.history.push( `/broadcast/facebook` )}
                            style={this.getActiveTabStyle( `/broadcast/facebook` )}
                  />
                  <ListItem primaryText="Twitter"
                            leftIcon={<i className="fa text-center fa-twitter" style={{ fontSize: 20 }}/>}
                            onClick={() => this.props.history.push( `/broadcast/twitter` )}
                            style={this.getActiveTabStyle( `/broadcast/twitter` )}
                  />
                </List>
              </div>

              <Divider/>
              <div className="box-header">Logs</div>
              <div className="box-body py-0">
                <ListItem primaryText={<Translate id="publishedBroadcast"/>}
                          leftIcon={<i className="fa text-center fa-list-ul" style={{ fontSize: 20 }}/>}
                          onClick={() => this.props.history.push( `/broadcast/logs` )}
                          style={this.getActiveTabStyle( `/broadcast/logs` )}
                />
              </div>
            </section>
          </div>

          <div className="col-md-9">
            <Switch>
              <Route path={`${this.props.match.path}/facebook`} component={Facebook}/>
              <Route path={`${this.props.match.path}/twitter`} component={Twitter}/>
              <Route path={`${this.props.match.path}/logs`} component={BroadcastList}/>
            </Switch>
          </div>
        </div>
      </div>
    )
  }
}

module.exports = Configuration;



// WEBPACK FOOTER //
// ./routes/app/routes/broadcast/index.js